import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { useEffect, useRef } from 'react'
import { FoundationsEnums } from '../../enum'
import HC_more from 'highcharts/highcharts-more'
import { useSelector } from 'react-redux'
import { AppState, getBusinessParameterList } from '../../Redux/store'
import { getDurationDisplayFromSecs } from '../Charts/chartHelperFunctions'
HC_more(Highcharts)


const targetConditionNumberType: any = {
    1: 'Stay under',
    2: 'Stay close to',
    3: 'Aim to exceed',
}

const gaugeColors = {
    green: 'rgba(16, 173, 45, 1)',
    red: 'rgba(219, 24, 24, 1)',
    darkRed: 'rgba(179, 18, 18, 1)',
    lightBlue: 'rgba(66, 151, 215, .6)',
    blue: 'rgba(66, 151, 215, 1)',
    neutral: 'rgba(0,0,0,0.2)',
}

//create code to loop thorough and create each measure for a summary tile
// create single summary gague based on measure

export const SummaryGauge = (props: {
    measure: {
        AllowDrillThru?: any
        UserTargetId: number
        UserTarget: { TargetType: number; TargetValue: string; TargetInputType: number }
        DefaultTarget: { TargetType: number; TargetValue: string; TargetInputType: number }
        SingleValueReportId: number
        SingleValueReport: { MeasureList: { MetaData: { DataType: any } }[] }
        MetaData: { DataType: any }
    }
    measureObject: { MeasureName?: any; DataPoint?: any }
    vuId: number
    index: number
    showKmi: (index: number) => void
}) => {
    const handleEditTarget = (e: Event) => {
        e.stopPropagation()
        props.showKmi(index)
    }

    useEffect(() => {
        document.querySelectorAll(`#edit_target_${vuId}_${index}`).forEach((element) => {
            element.addEventListener('click', handleEditTarget)
        })

        return () => {
            // Clean up event listeners
            document.querySelectorAll(`#edit_target_${vuId}_${index}`).forEach((element) => {
                element.removeEventListener('click', handleEditTarget)
            })
        }
    }, [])

    const { measure, measureObject, vuId, index } = props
    const drillthruAllowed = measure.AllowDrillThru.toUpperCase() == 'Y'

    const measureName = measureObject.MeasureName
    const measureNameHtml =
        measureName.length > 25
            ? '<span>' + measureName.substring(0, 25) + '... </span>'
            : '<span>' + measureName + '</span>'

    const [currentTarget, value, target_one, target_two, isStayCloseTo, maxValue]: any[] =
        getTargets(measure, measureObject.DataPoint)

    const [plotBands, dataValueColorClass, dialColor] = getColors(
        value,
        maxValue,
        currentTarget.TargetType,
        target_one,
        target_two
    )

    const chartOptions = {
        chart: {
            type: 'gauge',
            backgroundColor: 'rgba(0,0,0,0)',
        },
        exporting: {
            enabled: true,
            type: 'image/png',
            filename: 'healthlevel_chart',
            buttons: {
                printButton: {
                    enabled: false,
                },
                exportButton: {
                    enabled: false,
                },
            },
        },
        navigation: {
            buttonOptions: {
                enabled: false,
            },
        },
        title: {
            text: `<div class="gauge-title">
                    <span style="font-size:13px; min-width:100px;">
                        <b
                        id="label_${vuId}_0_${index}"
                        >${measureNameHtml}:</b> 
                        <b 
                            id="td_${vuId}_0_${index}"
                            class="measureValue ${dataValueColorClass}">${measureObject.DataPoint}
                        </b>
                    </span>
                    </div>`,
            useHTML: true,
            margin: -20,
        },
        tooltip: {
            enabled: false,
        },
        plotOptions: {
            gauge: {
                dial: {
                    backgroundColor: dialColor,
                    baseLength: '1%',
                    baseWidth: 8,
                    rearLength: 1,
                    topWidth: 0,
                    borderColor: '#B17964',
                    borderWidth: 0,
                    radius: 70,
                },
                pivot: {
                    radius: 4,
                    backgroundColor: dialColor,
                },
                wrap: false,
            },
        },
        pane: {
            startAngle: -90,
            endAngle: 90,
            center: ['50%', '68%'],
            background: [],
        },
        yAxis: [
            {
                min: 0,
                max: maxValue,
                tickPositions: [],
                plotBands: plotBands,
            },
        ],

        series: [
            {
                name: 'Value',
                cursor: drillthruAllowed ? 'pointer' : 'cursor',
                data: [value],
                overshoot: 0,
                dataLabels: {
                    formatter: function () {
                        return `<span class="edit_measure_target" id="edit_target_${vuId}_${index}">
                        <div class="measure_target cursor-pointer" style="width:8rem; text-align: center;"> 
                        ${
                            currentTarget.TargetType !== 0
                                ? '<div class="gauge_datalabel">' +
                                  targetConditionNumberType[currentTarget.TargetType] +
                                  `${targetConditionNumberType[currentTarget.TargetType]?.includes('has') ? '' : ':'} ` +
                                  currentTarget.TargetValue.toString() +
                                  '</div><span class="edit_measure"> - Edit Target -</span>'
                                : '<span class="edit_measure"> - Edit Target -</span>'
                        } 
                      </div>
                    </span>
                    `
                    },
                    useHTML: true,
                    align: 'center',
                    borderWidth: 0,
                    verticalAlign: 'top',
                    y: 0,
                    overflow: 'allow',
                    allowOverlap: true,
                    style: {
                        wordBreak: 'break-all',
                        textOverflow: 'allow',
                        color: 'black',
                    },
                },
            },
            ...(currentTarget.TargetType !== 0
                ? [
                      {
                          data: [target_one],
                          type: 'gauge',
                          tooltip: {
                              enabled: false,
                          },
                          animation: false,
                          dataLabels: {
                              enabled: false,
                          },
                          dial: {
                              backgroundColor: '#333',
                              baseWidth: 3,
                              topWidth: 3,
                              baseLength: '100%',
                              radius: '100%',
                              rearLength: '-70%',
                          },
                      },
                  ]
                : []),
            ...(isStayCloseTo
                ? [
                      {
                          data: [target_two],
                          type: 'gauge',
                          animation: false,
                          tooltip: {
                              enabled: false,
                          },
                          dataLabels: {
                              enabled: false,
                          },
                          dial: {
                              backgroundColor: '#333',
                              baseWidth: 3,
                              topWidth: 3,
                              baseLength: '100%',
                              radius: '100%',
                              rearLength: '-70%',
                          },
                      },
                  ]
                : []),
        ],
        credits: {
            enabled: false,
        },
    }

    return (
        <>
            <HighchartsReact
                containerProps={{ style: { height: '144px', width: '100%' } }}
                highcharts={Highcharts}
                options={chartOptions}
            />
        </>
    )
}

const getColors = (
    value: number,
    maxValue: any,
    TargetType: any,
    target_one: number,
    target_two: number
) => {
    let dialColor = gaugeColors.blue
    let plotBands = [
        {
            from: 0,
            to: maxValue,
            className: 'blue-gauge-band',
            color: gaugeColors.lightBlue,
            innerRadius: '70%',
            outerRadius: '100%',
        },
    ]

    switch (TargetType) {
        case FoundationsEnums.TargetType.StayUnder:
            if (value >= target_one) {
                dialColor = gaugeColors.red
            } else {
                dialColor = gaugeColors.green
            }
            plotBands = [
                {
                    from: 0,
                    to: target_one,
                    color: gaugeColors.green,
                    className: 'green-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
                {
                    from: target_one,
                    to: value > target_one ? value : target_one,
                    color: gaugeColors.red,
                    className: 'red-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '101%',
                },
                {
                    from: value > target_one ? value : target_one,
                    to: maxValue,
                    color: gaugeColors.neutral,
                    className: 'neutral-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
            ]

            break
        case FoundationsEnums.TargetType.StayCloseTo:
            if (value > target_two || value < target_one) {
                dialColor = gaugeColors.red
            } else {
                dialColor = gaugeColors.green
            }

            plotBands = [
                {
                    from: 0,
                    to: value < target_one ? value : target_one,
                    color: gaugeColors.neutral,
                    className: 'neutral-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
                {
                    from: value < target_one ? value : target_one,
                    to: target_one,
                    color: gaugeColors.red,
                    className: 'red-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '101%',
                },
                {
                    from: target_one,
                    to: target_two,
                    color: gaugeColors.green,
                    className: 'green-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
                {
                    from: target_two,
                    to: value > target_two ? value : target_two,
                    color: gaugeColors.red,
                    className: 'red-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '101%',
                },
                {
                    from: value > target_two ? value : target_two,
                    to: maxValue,
                    color: gaugeColors.neutral,
                    className: 'neutral-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
            ]

            break
        case FoundationsEnums.TargetType.AimToExceed:
            if (value <= target_one) {
                dialColor = gaugeColors.red
            } else {
                dialColor = gaugeColors.green
            }
            plotBands = [
                {
                    from: 0,
                    to: value < target_one ? value : target_one,
                    color: gaugeColors.neutral,
                    className: 'neutral-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
                {
                    from: value < target_one ? value : target_one,
                    to: target_one,
                    color: gaugeColors.red,
                    className: 'red-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '101%',
                },
                {
                    from: target_one,
                    to: maxValue,
                    color: gaugeColors.green,
                    className: 'green-gauge-band',
                    innerRadius: '70%',
                    outerRadius: '100%',
                },
            ]
            break
        default:
            dialColor = gaugeColors.blue
            break
    }
    let dataValueColorClass =
        dialColor == gaugeColors.red ? 'gauge-red-label' : 'gauge-neutral-label'
    dataValueColorClass = dialColor == gaugeColors.red ? 'gauge-red-label' : dataValueColorClass

    return [plotBands, dataValueColorClass, dialColor]
}

const getTargets = (
    currentMeasure: {
        UserTargetId: number
        UserTarget: { TargetType: number; TargetValue: string; TargetInputType: number }
        DefaultTarget: { TargetType: number; TargetValue: string; TargetInputType: number }
        SingleValueReportId: number
        SingleValueReport: { MeasureList: { MetaData: { DataType: any } }[] }
        MetaData: { DataType: any }
    },
    DataPoint: { [s: string]: any }
) => {
    const bpList = useSelector((state: AppState) => getBusinessParameterList(state))
    let currentTarget = {
        TargetType: 0,
        TargetValue: '-1',
        TargetInputType: 0,
    }
    if (currentMeasure && currentMeasure.UserTargetId != 0) {
        currentTarget = { ...currentMeasure.UserTarget }
    } else {
        currentTarget = { ...currentMeasure.DefaultTarget }
    }

    if (currentTarget.TargetInputType == 1) {
        const parameter: any = bpList?.find(function (bp: { [s: string]: any }) {
            return bp.Id == currentTarget.TargetValue
        })
        if (!parameter) {
            currentTarget.TargetValue = '-1'
        } else {
            currentTarget.TargetValue = parameter?.BPValue || '-1'
        }
    }
    //FP-10376. Check if report is cascade report and fetch details from first measure of cascade report.
    const dataType =
        currentMeasure?.SingleValueReportId > 0
            ? currentMeasure?.SingleValueReport.MeasureList[0]?.MetaData?.DataType
            : currentMeasure?.MetaData?.DataType
    if (dataType == FoundationsEnums.HLDataType.HLDuration && currentTarget.TargetInputType != 1) {
        currentTarget.TargetValue = getDurationDisplayFromSecs(
            parseInt(currentTarget.TargetValue)
        )
    }

    let value: number
    let target_one: number

    if (dataType == FoundationsEnums.HLDataType.HLDuration) {
        value = convertTimeToInteger(DataPoint.toString())
        target_one = convertTimeToInteger(currentTarget.TargetValue.toString())
    } else {
        value = parseFloat(DataPoint.toString().replace(/[^\d\.\-]/g, ''))
        target_one = parseFloat(currentTarget.TargetValue.toString().replace(/[^\d\.\-]/g, ''))
    }

    let target_two: number | undefined = undefined
    let isStayCloseTo: boolean =
        currentTarget.TargetType === FoundationsEnums.TargetType.StayCloseTo
    let maxValue: number

    if (isStayCloseTo) {
        maxValue = value > target_one * 2 ? value : target_one * 2
        //FP-9997 Update target_two to be 10% greater than the current target_one value.
        target_two = target_one * 1.1
        //FP-9997 Reduce target_one to be 10% less than its current value.
        target_one = target_one * 0.9
    } else if (currentTarget.TargetType === 0) {
        maxValue = value * 2
    } else {
        maxValue = value > target_one * 2 ? value : target_one * 2
    }

    return [currentTarget, value, target_one, target_two, isStayCloseTo, maxValue]
}

const convertTimeToInteger = (time: string) => {
    if (time === '0') return 0
    let integerValue = 0
    let timeValue = time.split(':')
    timeValue.forEach((val) => {
        if (val.slice(-1) == 'd') {
            integerValue += parseInt(val.substring(0, val.length - 1)) * 86400
        } else if (val.slice(-1) == 'h') {
            integerValue += parseInt(val.substring(0, val.length - 1)) * 3600
        } else if (val.slice(-1) == 'm') {
            integerValue += parseInt(val.substring(0, val.length - 1)) * 60
        } else {
            integerValue += parseInt(val.substring(0, val.length - 1))
        }
    })
    return integerValue
}
